import React from 'react';

function healthCheck() {
  return (
    <React.Fragment>
      <p data-testid="health-check">OK</p>
    </React.Fragment>
  );
}

export default healthCheck;
